import * as Babel from '@babel/standalone';

// Attach Babel to window
if (typeof window !== 'undefined') {
  window.Babel = Babel;
}
